import { Checkbox, DatePicker, Form, Input, Typography } from "antd";
import React from "react";
import inputStyles from "../../../../../styles/Custom/Input.module.css";
import DietPlan from "../../DietPlan";
import useReceptionistMobilePickerProps from "../../../../Receptionist/receptionistMobilePickerProps";

const dischargeDayOptions = [
  { label: "Eating well", value: "eating_well" },
  { label: "Drinking well", value: "drinking_well" },
  { label: "Tolerating tube feeds well", value: "tolerating_tube_feeds" },
];
const DietInCenter = ({ form }) => {
  const mobilePickerProps = useReceptionistMobilePickerProps();
  return (
    <>
      <Typography className="forms-ip-sentence">
        <Typography.Text>
          The patient was stable and tolerated tube feeds. On
        </Typography.Text>
        <Form.Item style={{ display: "inline-block" }}>
          <DatePicker
            className={inputStyles.mdDatePicker}
            style={{ width: "150px", marginLeft: 5, marginRight: 5 }}
            inputReadOnly
            {...mobilePickerProps}
          />
        </Form.Item>
        <Typography.Text>
          the feeding tube was removed and he started drinking orally. He was
          continued on liquid diet for the next
        </Typography.Text>
        <Form.Item style={{ display: "inline-block" }} name="liquid_diet_date">
          <Input
            className={inputStyles.mdInput}
            style={{ width: "250px" }}
            placeholder="History of present illness"
          />
        </Form.Item>{" "}
        <Typography.Text>
          days and gradually converted to an oral soft and regular diet.
        </Typography.Text>
        <DietPlan form={form} />
        <Form.Item
          label="On the day of the discharge, the patient was cardio vascularly stable"
          name={"day_of_discharge"}
        >
          <Checkbox.Group options={dischargeDayOptions} />
        </Form.Item>
      </Typography>
    </>
  );
};

export default DietInCenter;
